module.exports = __webpack_public_path__ + "static/media/home.af2970e3.png";